// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f40577c7","455":"67b99b6c"}[chunkId] + ".chunk.js";
};